var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVolumeSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 26 26",
    height: 26,
    viewBox: "0 0 26 26",
    width: 26,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.261 9.556h-5.261v.004 6.879.004h5.261l7.135 4.394v-7.531-.612-7.531z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.555 7.333c-.051-.056-.106-.105-.166-.152-.002-.002-.004-.005-.008-.007-.234-.183-.526-.297-.848-.297-.766 0-1.387.621-1.387 1.386 0 .419.19.79.484 1.044l-.004.006c1.127.94 1.844 2.346 1.844 3.931 0 1.603-.743 3.036-1.916 3.976-.045.045-.08.08-.107.125-.188.233-.305.537-.305.859 0 .771.627 1.397 1.396 1.397.188 0 .367-.036.529-.099.089-.045.17-.09.25-.144.081-.054.152-.107.215-.179 1.656-1.451 2.705-3.573 2.705-5.937.001-2.357-1.04-4.468-2.682-5.909z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeSmall);
export default __webpack_public_path__ + "static/media/volume_small.dcb9a0a3a3e0396600ae0aacec003b93.svg";
export { ForwardRef as ReactComponent };